import { render, staticRenderFns } from "./TableLogImport.vue?vue&type=template&id=22dd52fe&"
import script from "./TableLogImport.vue?vue&type=script&lang=js&"
export * from "./TableLogImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports